import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-existing-user',
  templateUrl: './existing-user.component.html',
  styleUrls: ['./existing-user.component.scss']
})
export class ExistingUserComponent {
  @Output() continue = new EventEmitter<void>();

  onContinue() {
    this.continue.emit();
  }

  redirectToLogin() {
    window.location.href = window.location.origin + '/login';
  }
}
